import React from "react";
import classnames from "classnames";

import { ELoaderTheme, ESubPriceType, EVariants } from "../../types/enums";
import type { IOldButtonProps } from "../../types";

import styles from "./OldButtonContent.module.scss";
import { Loader } from "../../../../loader";

type IContentProps = Pick<
  IOldButtonProps,
  | "icon"
  | "secondIcon"
  | "loading"
  | "children"
  | "variant"
  | "priceClass"
  | "subPrice"
  | "subPriceType"
>;

export const OldButtonContent = ({
  icon,
  secondIcon,
  loading,
  children,
  variant,
  priceClass,
  subPrice,
  subPriceType,
}: IContentProps) => {
  const loaderMode =
    variant === EVariants.primary ? ELoaderTheme.light : ELoaderTheme.dark;

  /* Контент в качестве цены */
  if (variant === EVariants.price) {
    return (
      <div className={styles.price_container}>
        <div className={priceClass}>{children}</div>

        <div
          className={classnames(styles.subprice, {
            [styles.secondarySubpriceContainer]:
              subPriceType === ESubPriceType.secondary,
          })}
        >
          {subPrice}
        </div>
      </div>
    );
  }

  /* Контент в ReactNode и опциональных иконок */
  return (
    <>
      {icon && (
        <img
          src={icon}
          className={classnames(styles.icon, {
            [styles.icon_secondIcon]: secondIcon,
          })}
          alt=""
        />
      )}

      {loading && <Loader mode={loaderMode} />}

      {!loading && (
        <div className={classnames({ [styles.container]: secondIcon })}>
          {children}
        </div>
      )}

      {secondIcon && (
        <div className={styles.secondIconContainer}>
          <img src={secondIcon} className={styles.second_icon} alt="" />
        </div>
      )}
    </>
  );
};
